import $ from 'jquery'

function brochureDownloadForm(){
  $( document ).on('gform_confirmation_loaded', function( event, formId) {
    if ( formId == 5 ) {
        $( '.brochure-form-column' ).find( 'h3' ).remove()
    }
  });
}


export { brochureDownloadForm }